export default __webpack_public_path__ + "align-to-left.png";